<template>
  <div class="step-content"
       :class="{ loading: isLoading }">
    <ui-loading-circle v-if="isLoading" />
    <template v-else>
      <div class="content__group-name">
        <div class="input--wrap">
          <p class="label">{{ $t('page.registration.step2.labelGroup.label') }}</p>
          <ui-selectbox :value="groupName"
                        :items="categoryGroupList"
                        :maxHeight="230"
                        width="100%"
                        @changed="onSetPageAddFocusContent(1,0)"
                        @input="$emit('onGroupNameChange', $event)"/>
          <input v-if="groupName === -1"
                 type="text" id="groupNameDirect"
                 maxlength="50"
                 :class="{error: isValidatorEnabled && groupNameDirect.length >= 50}"
                 :placeholder="$t('common.placeHolder.enterGroupName')"
                 :value="groupNameDirect"
                 @focus="onSetPageAddFocusContent(1,0)"
                 @blur="isValidatorEnabled = true"
                 @input="$emit('onGroupNameDirectChange', $event.target.value.trim())">
          <i v-if="groupNameDirect" class="icon icon--close14" @click="$emit('onGroupNameDirectChange', '')"></i>
          <p v-if="isValidatorEnabled && (groupName === -1 && groupNameDirect.length >= 50)"
             class="validation-text">{{ $t('common.validationErrorText.groupNameExcess') }}</p>
        </div>
      </div>
      <div class="content__page-name">
        <div class="input--wrap">
          <p class="label"><label for="pageName">{{ $t('page.registration.step2.labelPage.label') }}</label></p>
          <input required id="pageName" type="text"
                 :value="pageName"
                 :placeholder="$t('common.placeHolder.enterPageName')"
                 @focus="onSetPageAddFocusContent(1,1)"
                 @input="$emit('onPageNameChange', $event.target.value.trim())">
          <i v-if="pageName" class="icon icon--close14" @click="$emit('onPageNameChange', '')"></i>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { getHostname, removeWww, getOriginFromUrl } from '@/libs/apply-helper'
import { getCategoryList } from '@/api/apply'
import UiSelectbox from '@/components/ui/UiSelectbox'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'

export default {
  name: 'RegistrationStep2',
  components: {
    UiSelectbox,
    UiLoadingCircle
  },
  props: [
    'groupName',
    'groupNameDirect',
    'pageName',
    'url'
  ],
  data () {
    return {
      isLoading: true,
      isValidatorEnabled: false,
      categoryGroupList: []
    }
  },
  computed: {
    realDomain () {
      const el = document.createElement('a')
      el.href = this.url
      const origin = getOriginFromUrl(el.href)
      return removeWww(getHostname(origin))
    }
  },
  created () {
    this.CATEGORY_UNTITLED = this.$t('common.untitled')
    this.categoryGroupList = [
      {
        text: this.CATEGORY_UNTITLED,
        value: this.CATEGORY_UNTITLED
      },
      {
        text: this.$t('common.directInput'),
        value: -1
      }
    ]

    getCategoryList(this.realDomain).then(data => {
      data.sort((a, b) => {
        return a.localeCompare(b)
      })
      for (const groupName of data) {
        if (![this.CATEGORY_UNTITLED].includes(groupName)) {
          this.categoryGroupList.push({
            text: groupName,
            value: groupName
          })
        }
      }

      const currentCategoryGroup = this.categoryGroupList.find(item => item.value === this.groupName)

      if (!currentCategoryGroup) {
        this.resetCategory()
      }
      this.isLoading = false
    }).catch(err => {
      console.error(err)
      this.resetCategory()
      this.isLoading = false
    })
  },
  methods: {
    ...mapMutations([
      'setPageAddGuideContent'
    ]),
    resetCategory () {
      this.$emit('onGroupNameChange', this.categoryGroupList[0].value)
      this.$emit('onGroupNameDirectChange', '')
    },
    onSetPageAddFocusContent (step, index) {
      const values = { currentStep: step, currentContentIndex: index }
      this.setPageAddGuideContent(values)
    }
  }
}
</script>

<style lang="scss" scoped>
.step-content {
  width: 480px;
  margin: 117px auto 0;

  &.loading {
    text-align: center;

    /deep/ .loading {
      position: static;
      transform: none;
    }
  }
}

.content__group-name .input--wrap {
  width: 100%;

  .icon--close14 {
    top: 86px !important;
    background-color: transparent;
  }
  #groupNameDirect {
    width: 100%;
    margin-top: 10px;
    &.error {
      border-color: $brandColor;
    }
  }
}

.content__page-name {
  margin-top: 40px;

  .input--wrap {
    width: 100%;

    #pageName {
      width: 100%;

      &:focus {
        border: 1px solid #289eef;
      }

      &.error {
        border-color: $errorColor;
      }
    }

    .icon--close14 {
      background-color: transparent;
    }
  }
}
</style>
